import {view} from '@sail/ui/deprecated';
import {defineMessages, FormattedMessage} from 'react-intl';
import {MetaRow} from './MetaRow';

const messages = defineMessages({
  chatEnded: {
    id: 'conversations_ui.chat.row.chatEnded.status',
    description: 'Message to show to indicate the chat has ended',
    defaultMessage: 'The chat has ended.',
  },
});

export const ChatEndedRow = () => (
  <view.div
    data-testid="chat-ended-row"
    className="uh-conversations-contains-meta-row"
  >
    <MetaRow>
      <FormattedMessage {...messages.chatEnded} />
    </MetaRow>
  </view.div>
);
